import React, {useContext, useEffect, useState} from 'react';
import {Select} from "antd";
import {getAllPatients, searchPatients} from "../../../utils/api-lists/patient.api";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {UserContext} from "../../../context/UserContext";

const PatientSearchComponent = () => {
    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [allPatients, setAllPatients] = useState([]);
    const [mappedPatients, setMappedPatients] = useState([]);

    const {user} = useContext(UserContext);

    const {t} = useTranslation('common');
    const navigate = useNavigate();

    useEffect(() => {
        getAllPatients(user.id).then((response) => {
            console.log(response);
            setAllPatients(response);
            const mapped = response.map((patient) => ({
                value: patient.id,
                label: `${patient.first_name} ${patient.last_name}`,
            }));
            setMappedPatients(mapped);
        });
    }, [user]);

    const fetchPatients = (value) => {
        if (value === '') {
            setSearchResults([]);
            return;
        }
        searchPatients(user.id, value).then((response) => {
            console.log(response);
            setSearchResults(response);
        });
    };

    const handleSearch = (value) => {
        setSearch(value);
        fetchPatients(value);
    }

    const filterPatients = (value) => {
        console.log(value);
        const filtered = allPatients.filter((patient) =>
            `${patient.first_name} ${patient.last_name}`.toLowerCase().includes(value.toLowerCase())
        );
        const mapped = filtered.map((patient) => ({
            value: patient.id,
            label: `${patient.first_name} ${patient.last_name}`,
        }));
        setMappedPatients(mapped);
    }

    const onChange = value => {
        console.log(`selected ${value}`);
        navigate('/patient-cabinet/' + value);

    };
    const onSearch = value => {
        handleSearch(value);
    };

    return (
        <div style={{width: '100%', padding: '0 10px'}}>
            <Select
                style={{
                    maxWidth: '600px',
                    width: '100%',
                }}
                showSearch
                placeholder={t('search')}
                value={search}
                optionFilterProp="label"
                onChange={onChange}
                onSearch={filterPatients}
                options={mappedPatients}
                notFoundContent={t("no_patients_found")} 
            />
        </div>
    );
};

export default PatientSearchComponent;